import { observer } from "mobx-react-lite";

import { DECISIONS_API } from "../../constants";
import { useParameters } from "../../store/parameters-store";
import { getPreviewModelName } from "../../utils";

import { DecisionQuestionsPreview } from "./DecisionQuestionsPreview";
import { ParametersWithTitle } from "./ParametersWithTitle";
import { ModelAndProviderPreview } from "./ModelAndProviderPreview";

import { useModelsStore } from "@/providers/ProviderAndModelsProvider/models-store";
import LoadingSpinner from "@/components/LoadingSpinner";

export const ModelPreviewContent = observer(
  ({ showGeneralInformation }: { showGeneralInformation: boolean }) => {
    const { parameters, promptData, selectedAPI, decisionQuestions } = useParameters();
    const { store: modelsStore } = useModelsStore({});
    const { modelsLoading } = modelsStore;

    if (modelsLoading) {
      return (
        <div className="my-8 flex h-full w-full items-center justify-center">
          <LoadingSpinner size={8} />
        </div>
      );
    }

    const modelName = getPreviewModelName(promptData);

    return modelName ? (
      <div className="max-h-[53vh] overflow-y-auto" style={{ scrollbarGutter: "stable" }}>
        <div className="w-full pb-2">
          {showGeneralInformation && <ModelAndProviderPreview promptData={promptData} />}
          {selectedAPI === DECISIONS_API ? (
            <DecisionQuestionsPreview questions={decisionQuestions} />
          ) : (
            <ParametersWithTitle parameters={parameters || []} />
          )}
        </div>
      </div>
    ) : (
      <p className="text-sm italic text-gray-400">No parameters set for this prompt version</p>
    );
  },
);
